import { useResetRecoilState, useSetRecoilState } from 'recoil';

import { scheduleFiltersState } from '@/state/standalone-schedules';
import { FilterSelection } from '@/types';
import { trackUser } from '@/utils/tracking';

interface UseScheduleFiltersInterface {
  updateFilters: (key: keyof FilterSelection, value: string[] | boolean) => void;
  resetFilter: (key: string) => void;
  resetAllFilters: () => void;
}

export const useScheduleFilters = (): UseScheduleFiltersInterface => {
  const setScheduleFilters = useSetRecoilState(scheduleFiltersState);
  const resetScheduleFilters = useResetRecoilState(scheduleFiltersState);

  const updateFilters = (key: keyof FilterSelection, value: string[] | boolean) => {
    if (value === undefined || value === null) {
      return;
    }

    trackUser.event('Filter Schedules', {
      filter: key,
      value,
    });

    setScheduleFilters((prev) => {
      if (typeof value === 'boolean') {
        return {
          ...prev,
          [key]: value,
        };
      }

      return {
        ...prev,
        [key]: value,
      };
    });
  };

  const resetFilter = (key: string) => {
    setScheduleFilters((prev) => {
      trackUser.event('Reset Schedules Filter', {
        filter: key,
      });

      return {
        ...prev,
        [key]: [],
      };
    });
  };

  const resetAllFilters = () => {
    resetScheduleFilters();

    trackUser.event('Reset All Schedules Filters');
  };

  return {
    updateFilters,
    resetFilter,
    resetAllFilters,
  };
};
